import { Modal } from './Modal';
import { Button } from './Button';
import { DateLabel } from './DateLabel';

/**
 * v0.4後半 月次実績一括入力 第2フェーズ I-4b (§6-2)「予定どおりの確認」。
 * 毎日確認は出さず、提出時に1回だけ表示する。対象日は「予定パターンを選んで時刻を確定させたが、
 * まだ確認していない (planned_time_confirmed !== 1)」日 (MonthlyAttendanceEntryPage 側で判定)。
 */
type Props = {
  open: boolean;
  dates: string[];
  onClose: () => void;
  onFixDate: (date: string) => void;
  onConfirm: () => void;
  submitting?: boolean;
};

export function PlannedTimeConfirmDialog({ open, dates, onClose, onFixDate, onConfirm, submitting }: Props) {
  return (
    <Modal open={open} onClose={onClose} title="予定どおりの確認" size="sm">
      <div className="space-y-3">
        <p className="text-sm text-text-body">予定どおりの時刻の日が {dates.length} 日あります。実際の時刻でしたか？</p>
        <ul className="space-y-1 max-h-[40vh] overflow-y-auto">
          {dates.map((date) => (
            <li key={date} className="flex items-center justify-between gap-2 text-sm py-1">
              <span><DateLabel date={date} withWeekday /></span>
              <button type="button" onClick={() => onFixDate(date)} className="min-h-[44px] sm:min-h-[36px] text-xs text-misespark-navy underline">その日を直す</button>
            </li>
          ))}
        </ul>
        <div className="flex items-center justify-end gap-2 pt-2 border-t border-surface-border">
          <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>キャンセル</Button>
          <Button type="button" variant="primary" onClick={onConfirm} loading={submitting}>実際の時刻でした</Button>
        </div>
      </div>
    </Modal>
  );
}
